import React from 'react';
import { ResourceTypes, ResourceOperations } from '../../../authentication/resources';
import { Restricted } from '../../../authentication';
import { AdminLink, AdminHeaderLink, AdminRouterLink } from '../components/admin-area-menu-links';
import { joinURL } from '../../../utilities';
import { adminAreaPathName, organizationTabLabel, organizationTabPathName } from '../admin-area-pathnames';
import { useTenantAddons } from '../../../components/tenant-addons';

import {
  userProfilesListPathName,
  usersListPathName,
  externalOperatorPathName,
  teamListPathName,
  externalOperatorResponsibilityAreaPathName,
  subjobcentersPathName,
  socialProviderUnitsPathName,
} from './organization-pathnames';

export function OrganizationMenu() {
  const { isTenantAddonEnabled } = useTenantAddons();
  const canSeeSocialProviderUnit = isTenantAddonEnabled(['socialudfører']);

  return (
    <Restricted
      actions={[
        { resourceType: ResourceTypes.BusinessConfiguration, resourceOperation: ResourceOperations.Read },
        { resourceType: ResourceTypes.User, resourceOperation: ResourceOperations.Read },
        { resourceType: ResourceTypes.Team, resourceOperation: ResourceOperations.Read },
        { resourceType: ResourceTypes.SubJobcenter, resourceOperation: ResourceOperations.Read },
        { resourceType: ResourceTypes.CrmRoles, resourceOperation: ResourceOperations.Write },
        { resourceType: ResourceTypes.UserProfile, resourceOperation: ResourceOperations.Write },
        { resourceType: ResourceTypes.ExternalOperatorAgreement, resourceOperation: ResourceOperations.Write },
        { resourceType: ResourceTypes.SocialProviderUnit, resourceOperation: ResourceOperations.Read },
      ]}
    >
      <AdminHeaderLink to={joinURL('/', adminAreaPathName, organizationTabPathName)}>{organizationTabLabel}</AdminHeaderLink>

      {/* Subjobcentre */}
      <Restricted denied=" " actions={[{ resourceType: ResourceTypes.SubJobcenter, resourceOperation: ResourceOperations.Read }]}>
        <AdminLink to={joinURL('/', adminAreaPathName, organizationTabPathName, subjobcentersPathName)}>Subjobcentre</AdminLink>
      </Restricted>

      <Restricted denied=" " actions={[{ resourceType: ResourceTypes.ExternalOperatorAgreement, resourceOperation: ResourceOperations.Write }]}>
        <AdminLink to={joinURL('/', adminAreaPathName, organizationTabPathName, externalOperatorPathName)}>Anden aktør</AdminLink>
      </Restricted>

      <Restricted denied=" " actions={[{ resourceType: ResourceTypes.BusinessConfiguration, resourceOperation: ResourceOperations.Read }]}>
        <AdminRouterLink to={joinURL('/', adminAreaPathName, organizationTabPathName, externalOperatorResponsibilityAreaPathName)}>Ansvarsområder</AdminRouterLink>
      </Restricted>

      {/* Brugere */}
      <Restricted denied=" " actions={[{ resourceType: ResourceTypes.User, resourceOperation: ResourceOperations.Read }]}>
        <AdminLink to={joinURL('/', adminAreaPathName, organizationTabPathName, usersListPathName)}>Brugere</AdminLink>
      </Restricted>

      {/* Brugerprofiler */}
      <Restricted denied=" " actions={[{ resourceType: ResourceTypes.UserProfile, resourceOperation: ResourceOperations.Write }]}>
        <AdminLink to={joinURL('/', adminAreaPathName, organizationTabPathName, userProfilesListPathName)}>Brugerprofiler</AdminLink>
      </Restricted>

      {/* Team */}
      <Restricted denied=" " actions={[{ resourceType: ResourceTypes.Team, resourceOperation: ResourceOperations.Read }]}>
        <AdminLink to={joinURL('/', adminAreaPathName, organizationTabPathName, teamListPathName)}>Team</AdminLink>
      </Restricted>

      {/* Udførerenhed */}
      {canSeeSocialProviderUnit && (
        <Restricted denied=" " actions={[{ resourceType: ResourceTypes.SocialProviderUnit, resourceOperation: ResourceOperations.Read }]}>
          <AdminLink to={joinURL('/', adminAreaPathName, organizationTabPathName, socialProviderUnitsPathName)}>Udførerenheder</AdminLink>
        </Restricted>
      )}
    </Restricted>
  );
}
